import React, { useState } from "react";
import {
  VideoPageHeader,
  VideoList,
  VideoTabs
} from "../../molecules/VideoList";
import { VideoDetailSidebar } from "../../molecules/VideoDetailSidebar";
import { Page } from "../../layouts/Page";
import VideoUploadSidebar from "../../molecules/VideoUploadSidebar/VideoUploadSidebar";
import ScheduleBroadcastSidebar from "../../molecules/VideoUploadSidebar/ScheduleBroadcastSidebar";

import { getColumnWidth, onColumnResizeHof } from "./helpers";
import useInputState from "../../hooks/useInputState";
import { useFilters, useVideoList, useProductList } from "./hooks";
import { BROADCAST_TABLE_COLUMNS, VIDEO_TABLE_COLUMNS, ARCHIVED_TABLE_COLUMNS} from "./constants";
import { Spinner } from "@blueprintjs/core";
import { useMutation } from "@apollo/react-hooks";
import {EditVideo} from "./mutations";

function Videos() {
  const [selectedVideo, setSelectedVideo] = useState();
  const [isVideoUploadOpen, setIsVideoUploadOpen] = useState(false);
  const [isScheduledBroadcastOpen, setIsScheduledBroadcastOpen] = useState(
    false
  );
  const [isVideoDetailsOpen, setIsVideoDetailsOpen] = useState(false);
  const [columnWidths, setColumnWidths] = useState([]);
  const [selectedTab, setSelectedTab] = useState("videos");
  const [searchText, setSearchText] = useInputState("");
  const onColumnResize = onColumnResizeHof({
    columnWidths,
    setColumnWidths,
    columns:
      selectedTab === "broadcasts"
        ? BROADCAST_TABLE_COLUMNS
        : (selectedTab === "videos") 
        ? VIDEO_TABLE_COLUMNS
        : ARCHIVED_TABLE_COLUMNS
  });

  const {
    filters,
    setFilters,
    filterOptions,
    loading: isFiltersLoading
  } = useFilters(selectedTab);

  const [editVideo] = useMutation(EditVideo);

  const { loading: isVideosLoading, videos, refetchVideos } = useVideoList({
    filters,
    scheduled: selectedTab === "broadcasts",
    searchText,
    isArchived:selectedTab === "archives",
    onUnarchiveVideo,
    onAddToReport
  });
  async function  onUnarchiveVideo (rowData) {
   await  editVideo({
      variables: {
        video: {
          id:rowData.id,
          visible:true,
          includeInReport:true
        }
      }
    });
    await refetchVideos();
  }
  async function onAddToReport (rowData){
    await  editVideo({
      variables: {
        video: {
          id:rowData.id,
          includeInReport: !rowData.includeInReport
        }
      }
    });
    await refetchVideos();
  }

  const { loading: isProductsLoading, products } = useProductList();

  const isLoading = isProductsLoading || isVideosLoading || isFiltersLoading;

  function openVideo(video) {
    setSelectedVideo(video);
    setIsVideoDetailsOpen(true);
  }

  function onUploadPress() {
    if (selectedTab === "videos") {
      setIsVideoUploadOpen(true);
    } else {
      setIsScheduledBroadcastOpen(true);
    }
  }

  return (
    <Page title="Your Videos" flex> 
      <VideoUploadSidebar
        sidebarIsOpen={isVideoUploadOpen}
        refetchVideos={refetchVideos}
        onDismiss={() => setIsVideoUploadOpen(false)}
      />

      <ScheduleBroadcastSidebar
        sidebarIsOpen={isScheduledBroadcastOpen}
        refetchVideos={refetchVideos}
        onDismiss={() => setIsScheduledBroadcastOpen(false)}
      />

      <VideoDetailSidebar
        video={selectedVideo}
        sidebarIsOpen={isVideoDetailsOpen}
        onDismiss={() => setIsVideoDetailsOpen(false)}
        filters={filters}
        searchText={searchText}
        refetchVideos={refetchVideos}
      />

      <VideoPageHeader
        onSearchTextChange={setSearchText}
        onUploadPress={onUploadPress}
        filterOptions={filterOptions}
        uploadBtnText={
          selectedTab === "broadcasts" ? "Add Broadcast" : "Add Video"
        }
        filters={filters}
        setFilters={setFilters}
        searchText={searchText}
        disableAddVideo={!products || !products.length || selectedTab === 'archives'}
      />

      <VideoTabs onChange={setSelectedTab} value={selectedTab} />
  
      <VideoList
        onAddVideo={() => onUploadPress()}
        filters={filters}
        products={products}
        searchText={searchText}
        isLoading={isLoading}
        videos={videos}
        columns={
          selectedTab === "broadcasts"
        ? BROADCAST_TABLE_COLUMNS
        : (selectedTab === "videos") 
        ? VIDEO_TABLE_COLUMNS
        : ARCHIVED_TABLE_COLUMNS
        }
        columnWidths={columnWidths}
        getColumnWidth={getColumnWidth(selectedTab)}
        onColumnResize={onColumnResize}
        onVideoClick={openVideo}
        selectedTab={selectedTab}
      />
    </Page>
  );
}

export default Videos;
